export enum AccountTypeEnum {
  ADMIN = 'ADMIN',
  // USER = 'USER',
  INSTRUMENT = 'INSTRUMENT'
}

